import { render, staticRenderFns } from "./Djjg2.vue?vue&type=template&id=8c3ca976&scoped=true"
import script from "./Djjg2.vue?vue&type=script&lang=js"
export * from "./Djjg2.vue?vue&type=script&lang=js"
import style0 from "./Djjg2.vue?vue&type=style&index=0&id=8c3ca976&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3ca976",
  null
  
)

export default component.exports